export default __webpack_public_path__ + "static/fb-image-a4e936eb72dbc2c90a8eb08120111a4a.jpg";